import axios from "axios";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import "./i18n";
import "./index.css";
import errorInterceptor from "./interceptors/errorInterceptor";
import {
	loadingErrorInterceptor,
	loadingRequestInterceptor,
	loadingResponseInterceptor,
} from "./interceptors/loadingInterceptor";
import status401Interceptor from "./interceptors/status401Interceptor";
import reportWebVitals from "./reportWebVitals";

// axios.interceptors.request.use(authInterceptor);
axios.defaults.withCredentials = true;
axios.interceptors.request.use(loadingRequestInterceptor);
axios.interceptors.response.use(
	loadingResponseInterceptor,
	loadingErrorInterceptor
);
axios.interceptors.response.use((config) => config, status401Interceptor);
axios.interceptors.response.use((config) => config, errorInterceptor);

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<Suspense fallback="...is loading">
		<Provider store={store}>
			{/* <React.StrictMode> */}
			<App />
			{/* </React.StrictMode> */}
		</Provider>
	</Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
